import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCoinEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 8.623c-.581-.664-1.317-1.113-2.116-1.291a3.6 3.6 0 0 0-2.376.29c-.75.368-1.39.986-1.84 1.777a5.4 5.4 0 0 0-.69 2.667c0 .949.24 1.877.69 2.667s1.09 1.409 1.84 1.776c.75.368 1.577.47 2.376.291.799-.178 1.535-.627 2.116-1.291m-2.892-4.82H6.6m0 2.754h5.508M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0"
    />
  </svg>
);
export default SvgCurrencyCoinEuro;
